<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        Histórico de Candidaturas
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="historicoCandidaturas"
        :loading="loadingHistorico"
        :search="search"
        loading-text="Carregando candidaturas..."
        no-data-text="Nenhuma candidatura encontrada"
      >
        <template v-slot:[`item.titulo`]="{ item }">
          {{ item.titulo || item.tituloVaga || "-" }}
        </template>

        <template v-slot:[`item.dataCriacao`]="{ item }">
          {{ formatarData(item.dataCriacao) }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="getColor(item.status)" dark small>
            {{ getStatus(item.status) }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="excluirItem(item)" color="error">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog de Confirmação de Exclusão -->
    <v-dialog v-model="dialogExclusao" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confirmar Exclusão</v-card-title>
        <v-card-text>
          Tem certeza que deseja excluir a candidatura da vaga
          <strong>{{ itemParaExcluir?.titulo }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="fecharDialog"
            >Cancelar</v-btn
          >
          <v-btn color="error" text @click="confirmarExclusao">Excluir</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "HistoricoCandidaturas",
  data() {
    return {
      search: "",
      dialogExclusao: false,
      itemParaExcluir: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Vaga", value: "titulo" },
        { text: "Data Aplicação", value: "dataCriacao" },
        { text: "Status", value: "status" },
        { text: "Observação", value: "observacao" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters("candidaturainterna", [
      "historicoCandidaturas",
      "loadingHistorico",
    ]),
  },
  watch: {
    loadingHistorico(value) {
      console.log("[HistoricoCandidaturas] loadingHistorico:", value);
    },
    historicoCandidaturas: {
      handler(value) {
        const total = Array.isArray(value) ? value.length : 0;
        console.log("[HistoricoCandidaturas] itens recebidos:", total);
        if (total > 0) {
          console.log(
            "[HistoricoCandidaturas] primeiro item (raw):",
            JSON.stringify(value[0]),
          );
          console.log(
            "[HistoricoCandidaturas] estrutura esperada: id, titulo, dataCriacao, status",
          );
        }
      },
      immediate: true,
    },
  },
  created() {
    console.log("[HistoricoCandidaturas] entrou na tela");
    this.carregarHistoricoCandidaturas()
      .then(() => {
        console.log("[HistoricoCandidaturas] ação finalizada");
      })
      .catch((error) => {
        console.error("[HistoricoCandidaturas] erro na ação:", error);
      });
  },
  methods: {
    ...mapActions("candidaturainterna", [
      "carregarHistoricoCandidaturas",
      "excluirCandidatura",
    ]),
    async excluirItem(item) {
      this.itemParaExcluir = item;
      this.dialogExclusao = true;
    },
    fecharDialog() {
      this.dialogExclusao = false;
      this.$nextTick(() => {
        this.itemParaExcluir = null;
      });
    },
    async confirmarExclusao() {
      if (this.itemParaExcluir) {
        try {
          await this.excluirCandidatura(this.itemParaExcluir.id);
          this.$toasted.success("Candidatura excluída com sucesso!");
          this.carregarHistoricoCandidaturas();
        } catch (error) {
          this.$toasted.error("Erro ao excluir candidatura: " + error.message);
        }
      }
      this.fecharDialog();
    },
    formatarData(data) {
      if (!data) return "-";
      const d = new Date(data);
      if (isNaN(d.getTime())) {
        console.warn("[HistoricoCandidaturas] Data inválida:", data);
        return data;
      }
      return d.toLocaleDateString("pt-BR");
    },
    getStatus(status) {
      switch (Number(status)) {
        case 1:
          return "Nova";
        case 9:
          return "Cancelada";
        default:
          return status;
      }
    },
    getColor(status) {
      switch (Number(status)) {
        case 1:
          return "green";
        case 9:
          return "red";
        default:
          return "grey";
      }
    },
  },
};
</script>
